var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((this.feed),function(post,key){return _c('CoPost',{key:key,staticClass:"mb-3",attrs:{"post":post}})}),(_vm.loading)?_c('CoLoadingIndicator'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }